(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .directive('autoRegSetPasswordForm', autoRegSetPasswordForm);

  function autoRegSetPasswordForm() {
    return {
      restrict: 'AE',
      templateUrl: 'modules/auto-reg/form/set-password-form.view.html',
      controller: 'autoRegSetPasswordFormCtrl',
      controllerAs: 'ctrl'
    };
  }
})();
